<template>
  <div class="pdb-20px">
    <qd-notification :closable="false" ref="element"
                    class="has-background-background is-paddingless">
      <div class="columns is-multiline" v-if="totaux">
        <div class="column is-narrow" v-for="(recapMontant, index) in getTabRecap" :key="index">
          <div class="card-content has-background-white">
            <b-icon
              v-if="!recapMontant.noRound"
              icon="circle"
              size="is-small"
              :type="recapMontant.colorRond">
            </b-icon>
            <span class="has-text-weight-bold">
            {{ $t(recapMontant.libelle )}} :
            <span class="is-pulled-right mgl-5px">
              {{ totaux[recapMontant.propriete].total | formatDevise }}
            </span>
            </span>
            <div>
              {{ $t('renouvellementCommande.totaux.patrimoine') }}
              <span class="is-pulled-right mgl-5px">
                {{ totaux[recapMontant.propriete].totalMntPatrimonial | formatDevise }}
              </span>
            </div>
            <div>
              {{ $t('renouvellementCommande.totaux.tlpe') }}
              <span class="is-pulled-right mgl-5px">
                {{ totaux[recapMontant.propriete].totalMntTLPE | formatDevise }}
              </span>
            </div>
            <div>
              {{ $t('renouvellementCommande.totaux.horsTlpe') }}
              <span class="is-pulled-right mgl-5px">
                {{ totaux[recapMontant.propriete].totalMntDiversHorsTlpe | formatDevise }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </qd-notification>
  </div>
</template>

<script>

import { getAllTotauxMntRenouvellement } from '@/api/commande';

export default {
  props: {
    filtres: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      totaux: null,
    };
  },
  computed: {
    getTabRecap() {
      return [
        {
          noRound: true,
          colorRond: null,
          libelle: 'renouvellementCommande.totaux.total',
          propriete: 'totalRenouvellement',
        },
        {
          noRound: false,
          colorRond: 'is-aRenouveler',
          libelle: 'renouvellementCommande.etat.aRenouveler',
          propriete: 'totalEnAttente',
        },
        {
          noRound: false,
          colorRond: 'is-primary',
          libelle: 'renouvellementCommande.etat.renouvele',
          propriete: 'totalRenouvele',
        },
        {
          noRound: false,
          colorRond: 'is-tacite',
          libelle: 'renouvellementCommande.etat.tacite',
          propriete: 'totalTacite',
        },
        {
          noRound: false,
          colorRond: 'is-nonRenouvelee',
          libelle: 'renouvellementCommande.etat.nonRenouvele',
          propriete: 'totalNonRenouvele',
        },
        {
          noRound: false,
          colorRond: 'is-enCours',
          libelle: 'renouvellementCommande.etat.enCours',
          propriete: 'totalEnCours',
        },
      ];
    },
  },
  methods: {
    async getTotauxRenouvellement() {
      const totaux = (await getAllTotauxMntRenouvellement(this.filtres)).data.result;
      return totaux;
    },
    updateTotaux() {
      const loadingComponent = this.$buefy.loading.open({ container: this.$refs.element.$el });
      this.getTotauxRenouvellement().then(totaux => {
        this.totaux = totaux;
        loadingComponent.close();
      }).catch(e => {
        loadingComponent.close();
        throw e;
      });
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: this.$refs.element.$el });
    this.getTotauxRenouvellement().then(totaux => {
      this.totaux = totaux;
      loadingComponent.close();
    }).catch(e => {
      loadingComponent.close();
      throw e;
    });
  },
};

</script>
